
    <div fxLayout="column" class="content">
      <h3 class="mat-title" fxLayout="row" fxLayoutAlign="space-between center">
        <span>{{ 'notifications' | translate | titlecase }}</span>
        <div fxLayout="row" fxLayoutGap="8px">
          <button mat-button (click)="onClearAll()">
            {{ 'clear-all' | translate | titlecase }}
          </button>
          <button mat-icon-button (click)="onClose()">
            <mat-icon svgIcon="close">clear</mat-icon>
          </button>
        </div>
      </h3>
      <ml-notifications-list
        [notifications]="notifications$ | async"
        [next]="next"
        [loadingMore]="loadingMore"
        (remove)="onRemove($event)"
        (loadMore)="onLoadMore()"
        (redirect)="onRedirect($event)"
      >
      </ml-notifications-list>
    </div>
  